import type { JSX } from 'react';

import classNames from 'classnames';

import styles from './Form.module.css';

export function Form({
  children,
  type,
  onSubmit,
  ref,
}: {
  children: React.ReactNode;
  type: 'grid' | 'vertical';
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  ref: React.RefObject<HTMLFormElement>;
}): JSX.Element {
  return (
    <form onSubmit={onSubmit} ref={ref}>
      <div className={classNames(styles.Form, styles[type])}>{children}</div>
    </form>
  );
}
